var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"href":`mailto:?subject=${_vm.subject}&body=${encodeURIComponent(_vm.body)}`,"block":_vm.block,"color":_vm.color,"dark":"","target":"_blank"}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":""}},[_vm._v("fas fa-inbox")]),_vm._v(" "+_vm._s(_vm.$t('Email'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }